export const bonuses = [
  {
    name: '16 Printable Activity Cards',
    benefit: 'Take each activity’s setup and instructions to the gym on a portable, printable card.',
    image:
      'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/29b0aff5-3e15-4f58-859e-017d981df68e/9afdbe15-27dc-4cd0-9fa9-5677d0417f2a-mockup.webp',
  },
  {
    name: 'Large-Group Organization Guide',
    benefit: 'Organize big classes with clear group sizes, stations and rotations.',
    image:
      'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/29b0aff5-3e15-4f58-859e-017d981df68e/98c84711-a5a2-48c7-b607-2d4b15757004-mockup.webp',
  },
  {
    name: 'Handball Skills Progression Map',
    benefit: 'See at a glance how the skills build from lesson to lesson across the unit.',
    image:
      'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/29b0aff5-3e15-4f58-859e-017d981df68e/7eba8a21-3921-4fdb-a53a-5ef2d2244a52-mockup.webp',
  },
  {
    name: 'Student Observation and Assessment Sheets',
    benefit: 'Record what you observe without a complicated assessment system.',
    image:
      'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/29b0aff5-3e15-4f58-859e-017d981df68e/1c92a848-2455-4de1-96fd-a57a823bce72-mockup.webp',
  },
  {
    name: 'Lesson Planning Worksheets',
    benefit: 'Adapt lesson plans, equipment and timings to your setting, and reflect after each class.',
    image:
      'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/ebook-images/29b0aff5-3e15-4f58-859e-017d981df68e/8b6aef57-0fe0-4efc-bc28-92c53da1fc03-mockup.webp',
  },
];
